import template from './confirmation-registration.html';

export default class SelfRegistrationConfirmationComponent {
  constructor() {
    this.template = template;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/registration/components/self-registration/confirmation-registration/confirmation-registration-component.js